var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.3333 1.83333C18.3333 0.825 17.5083 0 16.5 0H1.83333C0.825 0 0 0.825 0 1.83333V12.8333C0 13.8417 0.825 14.6667 1.83333 14.6667H16.5C17.5083 14.6667 18.3333 13.8417 18.3333 12.8333V1.83333ZM16.5 1.83333L9.16667 6.41667L1.83333 1.83333H16.5ZM16.5 12.8333H1.83333V3.66667L9.16667 8.25L16.5 3.66667V12.8333Z"}));
}

Email.defaultProps = {"width":"19","height":"15","viewBox":"0 0 19 15","fill":"none"};

module.exports = Email;

Email.default = Email;
